import { RootState } from 'reducers';
import { OptionProps } from 'react-apollo';
import {
  StockPositionDetailsQuery,
  StockPositionDetailsQueryVariables,
} from './__generated__/StockPositionDetailsQuery';
import { Props } from '.';

export const mapStateToProps = (state: RootState) => state.components.stockPositionDetails;

export type SelectorResult = ReturnType<typeof mapStateToProps>;

export const responseToProps = ({
  data,
}: OptionProps<
  Props & SelectorResult,
  StockPositionDetailsQuery,
  StockPositionDetailsQueryVariables
>) => {
  if (!data || !data.stocksRemote || !data.stocksRemote.position) {
    return {
      loading: !data || data.loading,
    };
  }

  const { position } = data.stocksRemote;

  return {
    transactions: position.history.list,
    summary: position.summary,
    loading: data.loading,
  };
};

export type Data = ReturnType<typeof responseToProps>;
